<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright">
<div class="copy">Copyright © 2002 by Alejandro Murguía</div>
<div class="copy">All rights reserved</div>
<div class="copy">Printed in the United States of America</div>
<div class="copy">First edition, 2002</div>
<div class="copy1">Requests for permission to reproduce material from this work should be sent to Permissions, University of Texas Press, P.O. Box 7819, Austin, TX 78713-7819.<br/><a href="http://utpress.utexas.edu/index.php/rp-form" target="_blank">utpress.utexas.edu/index.php/rp-form</a></div>
<div class="copy1">Library of Congress Cataloging-in-Publication Data</div>
<div class="copy">Library ebook ISBN: 978-0-292-79637-9</div>
<div class="copy">Individual ebook ISBN: 9780292796379</div>
<div class="copy">DOI: 10.7560/752658</div>
<div class="copy1">Murguía, Alejandro, 1949–</div>
<div class="copy2">The medicine of memory : a Mexican clan in California / by Alejandro Murguía. — 1st ed.</div>
<div class="copy" style="text-indent: 2em;">p. cm.</div>
<div class="copy2">Includes bibliographical references and index.</div>
<div class="copy2"><span class="small">ISBN</span> 0-292-75265-2 (alk. paper) — <span class="small">ISBN</span> 0-292-75267-9 (pbk. : alk. paper)</div>
<div class="copy2">1. Mexican Americans—California—Biography. 2. Mexican Americans—California—History. 3. Mexican American families—California—History. 4. Aztecs—First contact with Europeans—California—History. 5. Lugo family. 6. Olivas family. 7. Murguía family. 8. Murguía, Alejandro, 1949– . 9. Mexican Americans—California—San Francisco—Biography. 10. San Francisco (Calif.)—Biography. I. Title.</div>
<div class="copy2"><span class="small">F</span>870.<span class="small">M</span>5<span class="small">M</span>87    2002</div>
<div class="copy2">929’.2’0973—dc21</div>
<div class="copy" style="text-align:right;">2002010187</div>
<div> </div>
<div class="copy2">Frontispiece: Mission Dolores, 1856, watercolor, José Clemente Orozco Farías.</div>
<div class="copy2">Front cover photos: Soledad Lugo, c. 1944; the Murguías (standing, left to right) Arturo, Alvar, Enrique, Luis, (sitting, left to right) Petra and Margarita, and two unidentified children, Mexico City, c. 1940; (background) Mission Dolores, 1856, watercolor, José Clemente Orozco Farías.</div>
<div class="copy2">Back cover: (left to right) Ygnacio Lugo, Ramona Nájera Olivas Lugo, and Antonio Lugo, Colonia Horcasitas, San Fernando Valley, 1936. Photo courtesy of Roberto Olivas.</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?50b9e583